import React, { useEffect,useState } from 'react'
import { ShowIssuesReportsCommentsWrapper } from './ShowIssuesReportsComments.style'

export default function ShowIssuesReportsComments({data}) {
    const [comments,setComments] = useState([]);
    const [images,setImages] = useState([]);
    useEffect(()=>{
        if(data && data.description){
            let comm = JSON.parse(data.description);
            console.log(comm);
            let commfinal = comm.map((ele,index)=>{
                return {
                    index:index+1,
                    step_id:ele.step_id,
                    issueAt: ele.step_no==-1?"Question":ele.step_no==0?"Final Answer":ele.step_no==-2?"Hints/Solution":`Step No. ${ele.step_no ?? "NA"}`,
                    comment: ele.description,
                }   
            });
            setComments(commfinal);
            console.log(commfinal);
        }
        console.log(data.images);
        setImages(data.images?data.images:[]);
     

    },[])
  return (
    <ShowIssuesReportsCommentsWrapper>
         <p className='note'>NOTE: Fix and test all the issues before submitting the question. </p>
         <div>
            { <p style={{fontSize:"17px",fontWeight:"bold"}}> {images.length ?"User Submitted Images :":""} </p>}
            {
                  images.map((ele,index)=>{
                    console.log(ele);
                    return  <div className='imagesDiv'>
                            <img src={ele.image_url} className='image' alt="" />
                        </div>
                    
                })
             }
         </div>
         {
            comments.length && <p style={{fontSize:"17px",fontWeight:"bold"}}>User Comments : </p>

        }
             
        {
          
        
            comments.length && comments.map((ele,index)=>{
                return <div key={index} className='comments'>
                        <p className='issueAt'>Issue At - {ele.issueAt ?? "NA"}</p>
                        <ol>
                            {
                                ele.comment.map((ele,index)=>{
                                    return <li>{ele}</li>
                                })
                            }
                        </ol>
                    </div>
                
            })
        }
    </ShowIssuesReportsCommentsWrapper>
  )
}
